
const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000008';

const OVERLAP = 142; // centiunits (1.42in), endcap-to-endcap overlap (no rail between)
const ENDCAP_WIDTH = 372; // 3.72in, shared by both parts
const HEIGHT = 480; // 4.8in, shared by both parts

const endCapLeftColumn = 0;
const endCapRightColumn = endCapLeftColumn + ENDCAP_WIDTH - OVERLAP;

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock Ryobi End Caps Only Bundle',
  Version: 1,
  ProductTypeId: 97,
  Sku: 341827278, // TODO: real single-SKU bundle Sku for the End Caps set
  Surface: null,
  Matrix: { Rows: 1, Columns: 10, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'ryobi-endcap-left-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail End Cap - Left',
      ChoiceId: 284418,
      Origin: {
        Row: 0, Column: endCapLeftColumn, Height: HEIGHT, Width: ENDCAP_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'ryobi-endcap-right-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail End Cap - Right',
      ChoiceId: 284419,
      Origin: {
        Row: 0, Column: endCapRightColumn, Height: HEIGHT, Width: ENDCAP_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const ryobiEndcapsOnlyBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default ryobiEndcapsOnlyBundleMock;
